export const timecodeToFrame = (timecode, frameRate) => {
  const dropFrames = Math.round(frameRate * 0.066666)
  const timeBase = Math.round(frameRate)

  const hourFrames = timeBase * 60 * 60
  const minuteFrames = timeBase * 60

  const timecodeValues = timecode.split(/[:;]/g)
  const hours = parseInt(timecodeValues[0], 10)
  const minutes = parseInt(timecodeValues[1], 10)

  const totalMinutes = (60 * hours) + minutes

  const seconds = parseInt(timecodeValues[2], 10)
  const frames = parseInt(timecodeValues[3], 10)

  if (timecode.indexOf(';') > 0) {
    return ((hourFrames * hours) + (minuteFrames * minutes) + (timeBase * seconds) + frames) - (dropFrames * (totalMinutes - Math.floor(totalMinutes / 10)))
  } else {
    return ((hourFrames * hours) + (minuteFrames * minutes) + (timeBase * seconds) + frames)
  }
}

export const frameToTimecode = (frame = 0, frameRate) => {
  if (!frame) {
    frame = 0
  }

  const dropframes = [29.97, 59.94]

  if (dropframes.includes(frameRate)) {
    return frameToDropTimecode(frame, frameRate)
  } else {
    return frameToNonDropTimecode(frame, frameRate)
  }
}

export const frameToNonDropTimecode = (frame = 0, frameRate = 25) => {
  frameRate = Math.round(frameRate)

  if (!frame) {
    frame = 0
  }

  if (!frameRate) {
    frameRate = 25
  }

  let hh = Math.floor(frame / (3600 * frameRate))
  let mm = Math.floor((frame / (60 * frameRate)) % 60)
  let ss = Math.floor((frame / frameRate) % 60)
  let ff = parseInt(frame % frameRate, 10)

  hh = hh < 10 ? '0' + hh : hh
  mm = mm < 10 ? '0' + mm : mm
  ss = ss < 10 ? '0' + ss : ss
  ff = ff < 10 ? '0' + ff : ff

  return {
    hh,
    mm,
    ss,
    ff,
    drop: false
  }
}

export const frameToDropTimecode = (frame = 0, frameRate = 29.97) => {
  if (!frame) {
    frame = 0
  }

  if (!frameRate) {
    frameRate = 29.97
  }

  let d, m,
    intFrameRate = Math.round(frameRate),
    dropFrames = Math.round(frameRate * .066666),
    framesPerHour = Math.round(frameRate * 60 * 60),
    framesPer24Hours = framesPerHour * 24,
    framesPer10Mins = Math.round(frameRate * 60 * 10),
    framesPerMin = Math.round(frameRate * 60),
    frameNumber = frame % framesPer24Hours

  if (frameNumber < 0) {
    frameNumber = framesPer24Hours + frameNumber
  }

  d = Math.floor(frameNumber / framesPer10Mins)
  m = frameNumber % framesPer10Mins

  if (m > dropFrames) {
    frameNumber += (dropFrames * 9 * d) + dropFrames * Math.floor((m - dropFrames) / framesPerMin)
  } else {
    frameNumber += dropFrames * 9 * d
  }

  let hh = Math.floor(Math.floor(Math.floor(frameNumber / intFrameRate) / 60) / 60)
  let mm = Math.floor(Math.floor(frameNumber / intFrameRate) / 60) % 60
  let ss = Math.floor(frameNumber / intFrameRate) % 60
  let ff = parseInt(Math.floor(frameNumber % intFrameRate), 10)

  hh = hh < 10 ? '0' + hh : hh
  mm = mm < 10 ? '0' + mm : mm
  ss = ss < 10 ? '0' + ss : ss
  ff = ff < 10 ? '0' + ff : ff

  return {
    hh,
    mm,
    ss,
    ff,
    drop: true
  }
}

export const timecodeToString = timecode => {
  if (timecode) {
    const {
      hh,
      mm,
      ss,
      ff,
      drop
    } = timecode

    let timecodeString = ''

    if (drop) {
      timecodeString = `${hh}:${mm}:${ss};${ff}`
    } else {
      timecodeString = `${hh}:${mm}:${ss}:${ff}`
    }

    return timecodeString
  }
}

export const timeConvertor = millisec => {
  if (millisec) {
    const seconds = (millisec / 1000).toFixed(1)
    const minutes = (millisec / (1000 * 60)).toFixed(1)
    const hours = (millisec / (1000 * 60 * 60)).toFixed(1)
    const days = (millisec / (1000 * 60 * 60 * 24)).toFixed(1)

    if (seconds < 60) {
      return seconds + " s"
    } else if (minutes < 60) {
      return minutes + " m"
    } else if (hours < 24) {
      return hours + " h"
    } else {
      return days + " d"
    }
  } else {
    return null
  }
}

export const bytesConvertor = bytes => {
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) {
    return {
      value: 0,
      unit: 'B'
    }
  }
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)), 10)
  return {value: (bytes / Math.pow(1000, i)).toFixed(0), unit: sizes[i]}
}

export const sort = (sortColumn, sortDirection) => {
  return (a, b) => {
    if (sortColumn.toLowerCase().includes('date')) {
      let diff = new Date(a[sortColumn]) - new Date(b[sortColumn])

      if (sortDirection === 'desc') {
        diff *= -1
      }

      return diff
    }

    if(sortColumn.includes('orderName')) {
      const aNumber = parseInt(a[sortColumn].slice(3))
      const bNumber = parseInt(b[sortColumn].slice(3))

      let diff = aNumber - bNumber

      if(sortDirection === 'desc') {
        diff *= -1
      }

      return diff
    }

    let val = 0

    if (a[sortColumn] > b[sortColumn]) {
      val = 1
    }
    if (a[sortColumn] < b[sortColumn]) {
      val = -1
    }

    if (sortDirection === 'desc') {
      val *= -1
    }

    return val
  }
}

export const sortItems = (items, sortColumn, sortDirection) =>
  items.sort(sort(sortColumn, sortDirection))

export const paginateItems = (items, pageNumber, pageSize) =>
  items.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

export const isEmail = str => /(.+)@(.+){2,}\.(.+){2,}/.test(str)

export const equalsIgnoreOrder = (a, b) => {
  if (a.length !== b.length)
    return false

  const uniqueValues = new Set([...a, ...b])

  for (const v of uniqueValues) {
    const aCount = a.filter(e => e === v).length
    const bCount = b.filter(e => e === v).length

    if (aCount !== bCount)
      return false
  }

  return true
}
